import * as React from "react";
import { SpinProps } from "antd/lib/spin";
import { Spin as AntSpin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";

const antIcon = <Loading3QuartersOutlined style={{ fontSize: 30, paddingBottom: 10 }} spin={true} />;

export const Spin: React.FunctionComponent<SpinProps> = ({ children, ...rest }) => {
  return (
    <AntSpin className="loader" indicator={antIcon} {...rest}>
      {children}
    </AntSpin>
  );
};
